














import { Component, Vue, Watch } from 'vue-property-decorator'
import { setThemeConfigs } from '@/utils/gamblingHelpers'
import { Action } from 'vuex-class'
import Cashier from '@/components/Cashier'

@Component({
  components: {
    Cashier
  }
})

export default class History extends Vue {
  @Action('setTheme') setTheme: any

  checkoutTheme!: string

  get spinnerColor () {
    return this.checkoutTheme === 'light' ? 'secondary--text' : 'white--text'
  }

  created () {
    const setCheckoutTheme = (theme: string) => this.checkoutTheme = theme
    setThemeConfigs(this.setTheme, setCheckoutTheme)
  }
}
